import { render } from "./DropdownListMenu.vue?vue&type=template&id=2a175253"
import script from "./DropdownListMenu.vue?vue&type=script&lang=js"
export * from "./DropdownListMenu.vue?vue&type=script&lang=js"

import exportComponent from "/builds/harapan-jaya/ecosystem/web-hrd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__